import { IPaymentMethod } from '@components/Sura/Stepper/types';

export const validationPaymentMethod = (method: IPaymentMethod) => {
  return Object.keys(method).length > 0 && method.enabled ? false : true;
};
